import { useQueries } from '@tanstack/react-query'

import {
  reservationCalendarTimeSlotsResponseSchema,
  type ReservationCalendarTimeSlotsResponse,
} from '../../../common/validations/reservationCalendarSchemas'
import {
  reservationCalendarTimeSlotsKey,
  buildReservationCalendarTimeSlotsPath,
} from './useAPIGetReservationCalendarTimeSlots'

import { get } from 'api/apiClient'

export const useAPIGetMultipleReservationCalendarTimeSlots = (
  contractUuid: string,
  calendarIds: string[],
  startDate: string,
  endDate: string
) => {
  return useQueries({
    queries: calendarIds.map((calendarId) => ({
      queryKey: reservationCalendarTimeSlotsKey(
        contractUuid,
        calendarId,
        startDate,
        endDate
      ),
      queryFn: () =>
        get<ReservationCalendarTimeSlotsResponse>(
          buildReservationCalendarTimeSlotsPath(
            contractUuid,
            calendarId,
            startDate,
            endDate
          ),
          reservationCalendarTimeSlotsResponseSchema
        ),
      staleTime: 0,
    })),
  })
}
